import { createContext, useContext } from 'react'

type InboxDrawerContextType = {
  closeDrawer: () => void
}

const InboxDrawerContext = createContext<InboxDrawerContextType | null>(null)

export const useInboxDrawer = (): InboxDrawerContextType => {
  const context = useContext(InboxDrawerContext)

  if (!context) {
    // Return a no-op function if context is not available (e.g., when not in drawer)
    return { closeDrawer: () => {} }
  }

  return context
}

export { InboxDrawerContext }
